import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetCapacityPlanDeliveryAddressMutationVariables = Types.Exact<{
  input: Types.SetCapacityPlanDeliveryAddressInput;
}>;


export type SetCapacityPlanDeliveryAddressMutation = { __typename?: 'Mutation', setCapacityPlanDeliveryAddress: { __typename?: 'SetCapacityPlanDeliveryAddressPayload', capacityPlanDeliveryAddressPayload?: { __typename?: 'CapacityPlanDeliveryAddressPayload', runId: any, deliveryId: any, address?: string | null, town?: string | null, village?: string | null, county?: string | null, validationError?: string | null, geocodeStatus: Types.CapacityPlanGeocodeStatus } | null, errors?: Array<{ __typename?: 'CapacityPlanUserError', code: Types.CapacityPlanErrorCode, message: string, runId?: any | null, deliveryId?: any | null }> | null } };


export const SetCapacityPlanDeliveryAddressDocument = gql`
    mutation SetCapacityPlanDeliveryAddress($input: SetCapacityPlanDeliveryAddressInput!) {
  setCapacityPlanDeliveryAddress(input: $input) {
    capacityPlanDeliveryAddressPayload {
      runId
      deliveryId
      address
      town
      village
      county
      validationError
      geocodeStatus
    }
    errors {
      ... on CapacityPlanUserError {
        code
        message
        runId
        deliveryId
      }
    }
  }
}
    `;
export type SetCapacityPlanDeliveryAddressMutationFn = Apollo.MutationFunction<SetCapacityPlanDeliveryAddressMutation, SetCapacityPlanDeliveryAddressMutationVariables>;

/**
 * __useSetCapacityPlanDeliveryAddressMutation__
 *
 * To run a mutation, you first call `useSetCapacityPlanDeliveryAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCapacityPlanDeliveryAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCapacityPlanDeliveryAddressMutation, { data, loading, error }] = useSetCapacityPlanDeliveryAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCapacityPlanDeliveryAddressMutation(baseOptions?: Apollo.MutationHookOptions<SetCapacityPlanDeliveryAddressMutation, SetCapacityPlanDeliveryAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCapacityPlanDeliveryAddressMutation, SetCapacityPlanDeliveryAddressMutationVariables>(SetCapacityPlanDeliveryAddressDocument, options);
      }
export type SetCapacityPlanDeliveryAddressMutationHookResult = ReturnType<typeof useSetCapacityPlanDeliveryAddressMutation>;
export type SetCapacityPlanDeliveryAddressMutationResult = Apollo.MutationResult<SetCapacityPlanDeliveryAddressMutation>;
export type SetCapacityPlanDeliveryAddressMutationOptions = Apollo.BaseMutationOptions<SetCapacityPlanDeliveryAddressMutation, SetCapacityPlanDeliveryAddressMutationVariables>;